import React from "react";
import { observer } from "mobx-react";
import { WalletStore } from "../../stores/wallet/wallet-store";
import { ConfirmModal } from "../../../../components/modal/components/confirm-modal/confirm-modal";
import "./confirm-disable-auto-charge-modal.scss";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";

interface IProps {
    store: WalletStore;
    onCloseClick: () => void;
}

const ConfirmDisableAutoChargeModal: React.FC<IProps> = observer(({ store, onCloseClick }) => {
    return (
        <ConfirmModal
            title={<FontBody1 variant={FONT_VARIANT.BOLD}>{"Are you sure you want to disable auto-recharge?"}</FontBody1>}
            text={
                <div className="confirm-disable-auto-charge-in-wallet-modal">
                    {"Disabling auto-recharge means your wallet won’t be automatically topped up with credits anymore. If your balance gets too low, you may have issues creating ReturnGO labels."}
                </div>
            }
            isCloseDisabled={store.isDeleting}
            cancelButton={{
                title: "Cancel",
                onClick: onCloseClick,
                disabled: store.isDeleting,
            }} okButton={{
                title: "Disable auto-recharge",
                onClick: store.disableAutoRecharge,
                hasLoader: true,
                isLoading: store.isDeleting,
            }}
        />
    );
});

export default ConfirmDisableAutoChargeModal;